// extracted by mini-css-extract-plugin
export var swiper = "styles-module--swiper--2Zj2A";
export var swiper_cntrls = "styles-module--swiper_cntrls--3SKsF";
export var slide = "styles-module--slide--3QvGh";